/**
 * Device State Slice
 * Manages device-related state
 */

export const createDeviceSlice = (set, get) => ({
  // Device list
  devices: [],
  setDevices: (devices) => set({ devices }),
  
  // Selected device
  selectedDevice: null,
  setSelectedDevice: (device) => set({ selectedDevice: device }),
  
  // Device filters
  filters: {
    search: '',
    status: 'all', // 'all', 'online', 'offline'
    type: 'all', // 'all', 'HC001', 'HX002', etc.
  },
  setFilters: (filters) =>
    set((state) => ({
      filters: { ...state.filters, ...filters },
    })),
  resetFilters: () =>
    set({
      filters: {
        search: '',
        status: 'all',
        type: 'all',
      },
    }),

  // Device loading state
  devicesLoading: false,
  setDevicesLoading: (loading) => set({ devicesLoading: loading }),
});






